import { TextEntryFilterOption } from '../types';
import { PositionTextEntry } from '../../components/PositionTextEntry';

export const config: TextEntryFilterOption = {
  id: 'omicsExplorer.filters.position',
  title: {
    id: 'omicsExplorer.filters.position',
    defaultMessage: 'Position',
  },
  content: PositionTextEntry,
  injectedProps: {
    searchKey: 'position',
    textEntryOption: {
      id: 'omicsExplorer.filters.position',
      searchValue: '',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.position.placeholderLabel',
        defaultMessage: 'chr5:7709402',
      },
    },
  },
};
